import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    cases: {}
  }),
  getters: {
    cases: state => {
      const cases = Object.values(state.cases)
      cases.sort((a, b) => {
        if (a.start_time < b.start_time) {
          return 1
        }
        if (a.start_time > b.start_time) {
          return -1
        }
        return 0
      })
      return cases
    },
    byId: state => id => state.cases[id],
    comment: state => id => state.cases[id].comment,
    conclusion: state => id => state.cases[id].conclusion,
    diagnosis: state => (id) => { return (state.cases[id] ? state.cases[id].diagnosis : null) },
    diagnosisById: state => (id) => (diagnosisId) => state.cases[id].diagnosis.filter((item) => { return item.id === diagnosisId })[0],
    preliminaryDiagnosis: state => id => state.cases[id].diagnosis.filter((item) => { return item.type === 'preliminary' }),
    finalDiagnosis: state => id => state.cases[id].diagnosis.filter((item) => { return item.type === 'final' }),
    treatments: state => (id) => state.cases[id].treatments,
    treatmentDrugs: state => (id) => state.cases[id].treatments.filter((item) => { return item.type === 'Drug' }),
    treatmentRecommendations: state => (id) => state.cases[id].treatments.filter((item) => { return item.type === 'Recommendation' }),
    files: state => id => state.cases[id].files,
    serviceRequests: state => id => state.cases[id].service_requests,
    serviceRequestsIds: state => id => state.cases[id].service_requests.map((v) => { return v.service_id }),
    serviceRequestsActive: state => id => state.cases[id].service_requests.filter((v) => { return v.status === 'active' }),
    serviceRequestsFulfil: state => id => state.cases[id].service_requests.filter((v) => { return v.status === 'fulfilled' }),
    serviceRequestsFail: state => id => state.cases[id].service_requests.filter((v) => { return v.status === 'failed' }),
    serviceRequestsCancel: state => id => state.cases[id].service_requests.filter((v) => { return v.status === 'cancelled' }),
    references: state => id => state.cases[id].references,
    hasReference: state => id => caseId => {
      for (const c of state.cases[id].references) {
        if (c.referenced_patient_case_id === caseId) {
          return true
        }
      }
      return false
    },
    refByCase: state => id => caseId => {
      for (const ref of state.cases[id].references) {
        if (ref.referenced_patient_case_id === caseId) {
          return ref
        }
      }
      return null
    },
    evidences: state => id => state.cases[id].evidences,
    evidencesPresent: state => id => state.cases[id].evidences.filter((v) => { return v.choice === 'present' && !v.is_initial && !v.is_featured }),
    evidencesAbsent: state => id => state.cases[id].evidences.filter((v) => { return v.choice === 'absent' && !v.is_initial && !v.is_featured }),
    evidencesInitial: state => id => state.cases[id].evidences.filter((v) => {
      return v.source && v.source === 'initial'
    }),
    evidencesFeatured: state => id => state.cases[id].evidences.filter((v) => { return v.is_featured && !v.is_initial }),
    labtests: state => id => state.cases[id].labtests,
    patientGender: state => id => {
      return state.cases[id].schedule.patient.gender
    },
    patientAge: state => id => {
      return {
        value: state.cases[id].schedule.patient.age,
        unit: state.cases[id].schedule.patient.age_unit
      }
    },
    active: state => {
      const cases = []
      for (const c of Object.values(state.cases)) {
        if (c.status === 'active') {
          cases.push(c)
        }
      }
      return cases
    },
    completed: state => {
      const cases = []
      for (const c of Object.values(state.cases)) {
        if (c.status === 'completed') {
          cases.push(c)
        }
      }
      return cases
    }
  },
  mutations: {
    set (
      state,
      {
        id,
        schedule_id,
        schedule,
        patient_id,
        clinic_service_id,
        clinic_id,
        service_id,
        is_personal,
        template,
        category_id,
        assignee_id,
        start_time,
        status,
        comment,
        conclusion,
        evidences,
        labtests,
        files,
        diagnoses,
        service_requests,
        references,
        treatments,
        created_at,
        created_by
      }
    ) {
      if (!state.cases[id]) {
        Vue.set(state.cases, id, {})
      }
      Vue.set(state.cases[id], 'id', id)
      Vue.set(state.cases[id], 'schedule_id', schedule_id)
      Vue.set(state.cases[id], 'schedule', schedule)
      Vue.set(state.cases[id], 'patient_id', patient_id)
      Vue.set(state.cases[id], 'clinic_service_id', clinic_service_id)
      Vue.set(state.cases[id], 'clinic_id', clinic_id)
      Vue.set(state.cases[id], 'service_id', service_id)
      Vue.set(state.cases[id], 'is_personal', is_personal)
      Vue.set(state.cases[id], 'template', template)
      Vue.set(state.cases[id], 'category_id', category_id)
      Vue.set(state.cases[id], 'assignee_id', assignee_id)
      Vue.set(state.cases[id], 'start_time', start_time)
      Vue.set(state.cases[id], 'status', status)
      Vue.set(state.cases[id], 'comment', comment)
      Vue.set(state.cases[id], 'conclusion', conclusion)
      Vue.set(state.cases[id], 'evidences', evidences)
      Vue.set(state.cases[id], 'labtests', labtests)
      Vue.set(state.cases[id], 'files', files)
      Vue.set(state.cases[id], 'diagnosis', diagnoses)
      Vue.set(state.cases[id], 'service_requests', service_requests)
      Vue.set(state.cases[id], 'references', references)
      Vue.set(state.cases[id], 'treatments', treatments)
      Vue.set(state.cases[id], 'created_at', created_at)
      Vue.set(state.cases[id], 'created_by', created_by)
    },
    setTreatment (state, { id, treatment }) {
      console.log('setTreatment')
      if (!state.cases[id]) {
        return
      }
      let found = false
      for (const i in state.cases[id].treatments) {
        if (state.cases[id].treatments[i].id === treatment.id) {
          Vue.set(state.cases[id].treatments, i, treatment)
          found = true
          break
        }
      }
      if (!found) {
        state.cases[id].treatments.push(treatment)
      }
      // console.log('->>>>', state.cases[id].treatments)
      state.cases[id].treatments.sort((a, b) => {
        if (a.created_at < b.created_at) {
          return -1
        }
        if (a.created_at > b.created_at) {
          return 1
        }
        return 0
      })
    },
    setComment (state, { id, comment }) {
      Vue.set(state.cases[id], 'comment', comment)
    },
    setConclusion (state, { id, conclusion }) {
      Vue.set(state.cases[id], 'conclusion', conclusion)
    },
    setDiagnosis (state, { id, diagnosis }) {
      if (!state.cases[id] && !state.cases[id].diagnosis) {
        return
      }
      for (const i in state.cases[id].diagnosis) {
        if (state.cases[id].diagnosis[i].id === diagnosis.id) {
          Vue.set(state.cases[id].diagnosis, i, diagnosis)
          return
        }
      }
      state.cases[id].diagnosis.push(diagnosis)
    },
    setEvidence (state, { id, evidence }) {
      if (!state.cases[id] && !state.cases[id].evidences) {
        return
      }
      for (const i in state.cases[id].evidences) {
        if (state.cases[id].evidences[i].id === evidence.id) {
          Vue.set(state.cases[id].evidences, i, evidence)
          return
        }
      }
      state.cases[id].evidences.push(evidence)
    },
    setServiceRequest (state, { id, serviceRequest }) {
      if (!state.cases[id] && !state.cases[id].service_requests) {
        return
      }
      for (const i in state.cases[id].service_requests) {
        if (state.cases[id].service_requests[i].id === serviceRequest.id) {
          Vue.set(state.cases[id].service_requests, i, serviceRequest)
          return
        }
      }
      state.cases[id].service_requests.push(serviceRequest)
    },
    pushEvidence (state, { id, evidence }) {
      if (!state.cases[id].evidences) {
        Vue.set(state.cases[id], 'evidences', evidence)
      }
      state.cases[id].evidences.push(evidence)
    },
    removeEvidence (state, { id, evidenceId }) {
      for (const i in state.cases[id].evidences) {
        if (state.cases[id].evidences[i].id === evidenceId) {
          state.cases[id].evidences.splice(i, 1)
        }
      }
    },
    setLabtest (state, { id, labtest }) {
      if (!state.cases[id] && !state.cases[id].labtests) {
        return
      }
      for (const i in state.cases[id].labtests) {
        if (state.cases[id].labtests[i].id === labtest.id) {
          Vue.set(state.cases[id].labtests, i, labtest)
          return
        }
      }
      state.cases[id].labtests.push(labtest)
    },
    pushLabtest (state, { id, labtest }) {
      if (!state.cases[id].labtests) {
        Vue.set(state.cases[id], 'labtests', [])
      }
      state.cases[id].labtests.push(labtest)
    },
    removeLabtest (state, { id, labtestId }) {
      for (const i in state.cases[id].labtests) {
        if (state.cases[id].labtests[i].id === labtestId) {
          state.cases[id].labtests.splice(i, 1)
        }
      }
    },
    pushFile (state, { id, file }) {
      if (!state.cases[id].files) {
        Vue.set(state.cases[id], 'files', [])
      }
      state.cases[id].files.push(file)
    },
    removeFile (state, { id, fileId }) {
      if (!state.cases[id].files) {
        return
      }
      for (const i in state.cases[id].files) {
        if (state.cases[id].files[i].id === fileId) {
          state.cases[id].files.splice(i, 1)
        }
      }
    },
    pushReference (state, { id, ref }) {
      if (!state.cases[id].references) {
        Vue.set(state.cases[id], 'references', [])
      }
      state.cases[id].references.push(ref)
    },
    removeReference (state, { id, refId }) {
      if (!state.cases[id].references) {
        return
      }
      for (const i in state.cases[id].references) {
        if (state.cases[id].references[i].id === refId) {
          state.cases[id].references.splice(i, 1)
        }
      }
    },
    reset (state) {
      Vue.set(state, 'cases', {})
    }
  }
}
